import type { User } from './types'

interface RealmAccessClaims {
  roles?: string[]
}

interface TokenClaims {
  sub?: string
  iss?: string
  preferred_username?: string
  email?: string
  given_name?: string
  family_name?: string
  scope?: string
  tenant_code?: string
  tenantCode?: string
  tenant?: string
  realm_access?: RealmAccessClaims
}

export function parseJWT(token: string): TokenClaims {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(char => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('')
    )
    return JSON.parse(jsonPayload) as TokenClaims
  } catch {
    return {}
  }
}

export function userFromToken(token: string): User {
  const claims = parseJWT(token)
  return {
    id: claims.sub || '',
    username: claims.preferred_username || '',
    email: claims.email,
    firstName: claims.given_name,
    lastName: claims.family_name,
    roles: claims.realm_access?.roles || [],
    tenantCode: claims.tenant_code || claims.tenantCode || claims.tenant,
    issuer: claims.iss,
  }
}

export function tokenHasScope(token: string | null, scope: string): boolean {
  if (!token) {
    return false
  }

  const claims = parseJWT(token)
  const tokenScopes = claims.scope || ''
  return tokenScopes.split(' ').includes(scope) || tokenScopes.includes('admin:*')
}
